"use strict";

import "./POIList.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import poiStore from "./../../store/pois";
import selectedPOIStore from "./../../store/selectedPOI";
import poiFilterExpressionStore from "./../../store/poiFilterExpression";
import pinnedPOIStore from "./../../store/pinnedPOIs";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import Button from "vwa/components/Button";
import List from "vwa/components/List";
import Filter from "./Filter";
import Summary from "./Summary";
import filterGroups from "vwa/utils/filterGroups";
import filterPOIs from "./filterPOIs";

import {getBoundsOfPOI} from "./../../utils/poi";

export default class POIList extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.setStoreListeners();
	}
	
	initState() {
		this.state = {
			pois:				filterGroups(poiStore.getAll()),
			filterExpression:	poiFilterExpressionStore.get(),
			selectedPOI:		selectedPOIStore.get(),
			pinnedPOIs:			pinnedPOIStore.getAll()
		};
	}
	
	setStoreListeners() {
		poiStore.on('change', pois => this.setState({pois: filterGroups(pois)}));
		poiFilterExpressionStore.on('change', filterExpression => this.setState({filterExpression}));
		selectedPOIStore.on('change', selectedPOI => this.setState({selectedPOI}));
		pinnedPOIStore.on('change', pinnedPOIs => this.setState({pinnedPOIs}));
	}
	
	// SIDE_EFFECT: referenciálisan ugyanaz a state és a nextState
	/* shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	} */
	
	handleFilterChange(expression) {
		dispatcher.dispatch('filterPOIs', expression);
	}
	
	handlePinChange(value) {
		const poiIds =  this.getListedPOIs().map(v => v._id);
		dispatcher.dispatch('pinPOIs', poiIds, value);
	}
	
	onSwitchPOIDetails(poiId) {
		const displayedDetails = displayedDetailsStore.get();
		if (!displayedDetails) {
			dispatcher.dispatch("openDetails", "POIDetails", poiId);
			setTimeout(() => this.focusPOI(poiId), 600);
		}
		else if (displayedDetails.id == poiId)
			dispatcher.dispatch("closeDetails", "POIDetails", poiId);
		else {
			dispatcher.dispatch("openDetails", "POIDetails", poiId);
			setTimeout(() => this.focusPOI(poiId));
		}
	}
	
	focusPOI(poiId) {
		dispatcher.dispatch('setMap', {
			bounds: getBoundsOfPOI(poiId).toJSON()
		});
	}
	
	getFilteredPOIs() {
		return filterPOIs(
			this.state.pois,
			this.state.filterExpression
		);
	}
	
	getListedPOIs() {
		const filteredPOIs = this.getFilteredPOIs()
		if(filteredPOIs){
			return filteredPOIs;
		}
		else if(this.state.pois){
			return this.state.pois;
		}
		else{
			return [];
		}
	}
	
	getListedPOIsPinStatus(){
		const currentListedPOIs = this.getListedPOIs().map(v => v._id);
		const pinnedCurrentListedPOIIds = currentListedPOIs.filter(id => 
			this.state.pinnedPOIs && this.state.pinnedPOIs.indexOf(id) > -1
		);
		
		if(pinnedCurrentListedPOIIds.length == 0){
			return 0;
		}
		else if(pinnedCurrentListedPOIIds.length < currentListedPOIs.length && pinnedCurrentListedPOIIds.length > 0){
			return 1;
		}
		else if(pinnedCurrentListedPOIIds.length == currentListedPOIs.length){
			return 2;
		}
		return 0;
	}
	
	renderFilter() {
		return (
			<Filter
				filterExpression={this.state.filterExpression}
				pinStatus={this.getListedPOIsPinStatus()}
				onFilter={this.handleFilterChange.bind(this)}
				onPinChange={this.handlePinChange.bind(this)}
			/>
		);
	}
	
	renderList(pois) {		
		return (
			<List>
				{pois ? pois.map(poi =>
					<Summary
						key={poi._id}
						poi={poi}
						onFocus={() => this.focusPOI(poi._id)}
						pinned={ this.state.pinnedPOIs ? ( this.state.pinnedPOIs.find(e => e==poi._id) ? true : false ) : false }
						onPinChange={value => dispatcher.dispatch('pinPOIs', [poi._id], value)}
						onSwitchPOIDetails={ _ => this.onSwitchPOIDetails(poi._id) }
					/>
				) : ""}
			</List>
		);
	}
	
	renderFullList() {
		return (
			<div className="ListContainer">
				{this.renderList(this.state.pois)}
			</div>
		);
	}
	
	renderFilteredList() {
		
		const className = classnames("ListContainer", {"Hidden": !this.getFilteredPOIs()});
		
		return (
			<div className={className}>
				<header>
					<Button icon="arrow-left" onClick={_ =>
						dispatcher.dispatch('filterPOIs', null)
					}/>
				</header>
				{this.renderList(this.getFilteredPOIs())}
			</div>
		);
	}
	
	renderSelectedList() {
		const className = classnames("ListContainer", {"Hidden": !this.state.selectedPOI});
		const poi = this.state.selectedPOI ? this.state.pois.find(p => p._id == this.state.selectedPOI) : null;
		return (
			<div className={className}>
				<header>
					<Button icon="arrow-left" onClick={_ =>
						dispatcher.dispatch('selectPOI', null)
					}/>
				</header>
				{this.renderList(poi ? [poi] : null)}
			</div>
		);
	}
	
	renderCreatePOIButton() {
		return <Button icon="plus" className="Floating Red" onClick={_=> this.props.onCreatePOI()}/>
	}
	
	render() {
		
		const filter = this.renderFilter();
		const fullList = this.renderFullList();
		const filteredList = this.renderFilteredList();
		const selectedList = this.renderSelectedList();
		const createPOIButton = this.renderCreatePOIButton();
		
		return (
			<div className="POIList">
				{filter}
				<div id="body">
					{fullList}
					{filteredList}
					{selectedList}
					{createPOIButton}
				</div>
			</div>
		);
	}
	
}

POIList.propTypes = {
	onCreatePOI:	React.PropTypes.func
};

POIList.defaultProps = {
	onCreatePOI:	location => {}
};


// WEBPACK FOOTER //
// ./src/view/POIList/POIList.jsx